import { createMemoryHistory, createRouter, createWebHistory } from 'vue-router';
import { getPublicSeoRoute, publicSeoRoutes } from '@/static/publicSeoRoutes.js';
const components = {
    landing: () => import('@/static/views/Landing.vue'),
    product: () => import('@/static/views/ProductPage.vue'),
    'product-feature': () => import('@/static/views/ProductFeaturePage.vue'),
    pricing: () => import('@/static/views/PricingPage.vue'),
    blogs: () => import('@/static/views/BlogsPage.vue'),
    guides: () => import('@/static/views/GuidesPage.vue'),
    resource: () => import('@/static/views/ResourcePage.vue'),
    terms: () => import('@/static/views/TermsPage.vue'),
    privacy: () => import('@/static/views/PrivacyPage.vue'),
    'privacy-delete': () => import('@/static/views/PrivacyDeletePage.vue'),
};

export function createPublicRouter({ ssr = false } = {}) {
    return createRouter({
        history: ssr ? createMemoryHistory() : createWebHistory(import.meta.env.BASE_URL),
        routes: publicSeoRoutes.map(route => ({
            path: route.path,
            name: `${route.id}:${route.locale}`,
            component: components[route.component],
            meta: {
                publicSeo: route,
                featureSlug: route.featureSlug,
                resourceSlug: route.resourceSlug,
            },
        })),
    });
}

export function applyRouteLocale(router, i18n) {
    router.beforeEach(to => {
        const route = getPublicSeoRoute(to.path);

        if (route) {
            i18n.global.locale.value = route.locale;
        }
    });
}
